import React, { useState } from 'react';
import globalStyles from 'assets/stylesheets/global-styles.module.scss';
import { Notification } from 'common/notification';
import { Footer, FooterType } from 'common/footer';
import styles from './forgot-password.module.scss';
import { ForgotPasswordStep1, ForgotPasswordStep2 } from './sections';

const ForgotPassword: React.FC = () => {
  const [step, setStep] = useState(0);
  const [showError, setShowError] = useState(false);
  const [email, setEmail] = useState('');

  const showForgotPasswordStep1View = () => (
    <ForgotPasswordStep1
      notifSuccess={() => setStep(1)}
      email={email}
      setEmail={setEmail}
    />
  );

  const showForgotPasswordStep2View = () => (
    <ForgotPasswordStep2 notifGoBack={() => setStep(0)} email={email} />
  );

  const showContentView = () => (
    <div className={globalStyles.signBoxContent}>
      <div className={styles.elements}>
        {step === 0 && showForgotPasswordStep1View()}
        {step === 1 && showForgotPasswordStep2View()}
      </div>
    </div>
  );

  const showErrorNotification = () => (
    <Notification handleClose={() => setShowError(false)} />
  );

  return (
    <div className={styles.container}>
      {showError && showErrorNotification()}
      <div className={styles.contentRight}>
        <div className={styles.contentFormWrapper}>{showContentView()}</div>
        <div className={styles.contentFooter}>
          <Footer footerType={FooterType.NoSignedUser} />
        </div>
      </div>
    </div>
  );
};

export { ForgotPassword };
